import { DepositRequestContent } from '@mpt-fo/common/shared/models/deposit.model';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { Component, OnInit, inject } from '@angular/core';

@Component({
	selector: 'app-deposit-request-details-modal',
	templateUrl: './deposit-request-details-modal.component.html',
	styleUrls: ['./deposit-request-details-modal.component.scss']
})
export class DepositRequestDetailsModalComponent implements OnInit {
	item: DepositRequestContent;
	modalCallback: any;
	readonly nzModalData = inject(NZ_MODAL_DATA, { optional: true }) ?? {};

	constructor(
		public modal: NzModalRef
	) { }

	ngOnInit(): void {
		this.modal.componentInstance = { ...this.modal.componentInstance, ...this.nzModalData };
		this.item = this.modal.componentInstance.data;
		this.modalCallback = this.modal.componentInstance.callback;
	}

	doAction(type) {
		this.modalCallback(type);
		this.modal.destroy();
	}

}
